module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"举报/阻挡","already_blocked":"已举报/阻挡的帖子。","cancel":"取消","submit":"举报","error":"举报受理失败。请确认输入内容。"}}')
  delete Component.options._Ctor
}
